import { PageFooter, Corner } from "./chrome";

const WHY_ITEMS = [
  { ico: "i.", title: "Certified in-house team", desc: "38 engineers and technicians — no sub-contracted crews on your rooftop." },
  { ico: "ii.", title: "End-to-end ownership", desc: "Survey, design, EPC, BESCOM approvals and AMC under one accountable roof." },
  { ico: "iii.", title: "Transparent costing", desc: "Engineered BOQ with line-item pricing and honest 25-year ROI projections." },
  { ico: "iv.", title: "Flexible financing", desc: "CAPEX, OPEX/RESCO and EMI options designed for every budget." },
];

export default function TestimonialPage() {
  return (
    <section className="page" data-testid="page-testimonial">
      <div className="grain" />
      <Corner section="VI · Trust" />
      <div className="page-inner">
        <div className="section-header">
          <div className="eyebrow">Our Testimonials</div>
          <h2 className="h-title">
            What customers<br />say about <em>INPACE POWER.</em>
          </h2>
        </div>

        <div className="testimonial-block">
          <p className="testimonial-text">
            We appreciate the quality of material supplied to us and the level of service provided by the dedicated team from INPACE POWER for the solar PV system installed at my residence. Truly an end-to-end, hassle-free experience.
          </p>
          <div className="testimonial-author">
            <div className="av">V</div>
            <div>
              <div className="who">Vikranth</div>
              <div className="where">Banashankari · Bangalore</div>
            </div>
          </div>
        </div>

        <div className="why-grid" style={{ marginTop: 40 }}>
          <div className="why-photo" />
          <div className="why-list">
            <div className="eyebrow" style={{ marginBottom: 14 }}>Why Choose INPACE POWER</div>
            {WHY_ITEMS.map((w) => (
              <div className="why-item" key={w.ico}>
                <div className="ico">{w.ico}</div>
                <div>
                  <h5>{w.title}</h5>
                  <p>{w.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <PageFooter num="14" />
    </section>
  );
}
